import { createFileRoute } from '@tanstack/react-router'

import { MailPricingPage } from '#/modules/thecargo-mail/pricing-page'

export const Route = createFileRoute('/_shell/mail-pricing')({
  component: MailPricingPage,
})
